import React from "react"
import PropTypes from "prop-types"

class IconeService extends React.Component {
  constructor(props) {
    super(props)
  }

  render () {
    const style = {  
        cadre: {
            position: 'relative',
            width: '40px',
            height: '40px',
        },

        cote: {
            width: '6px',
            height: '34px',
            transform: 'perspective(20px) rotateY(45deg)',
            border: '1px solid #333'
        },
        coteGauche: {
            position:'absolute',
            top:3,

        },
        coteHaut: {
            position: 'absolute',
            left:17,
            top:-14,
            transform:'rotate(90deg)'
        },
        coteBas: {
            position: 'absolute',
            left:17,
            top:20,
            transform:'rotate(-90deg)'
        },
        coteDroite: {
            position: 'absolute',
            left:34,
            top:3,
            transform:'rotate(180deg)'
        },
        isorel: {
            top:5,
            left:5,
            position:'absolute',
            height: '30px',
            width: '30px',
            background: ' rgb(205, 174, 131)',
        },
        vitre: {
            width: '50px',
            height: '50px',
            position: 'absolute',
            top: -5,
            left: -5,
            clip: 'rect(auto, 200px, auto, 25px)',
            transform: 'rotate(-45deg)'
        }

            
    }        
    return(
        <>
        {this.props.precoupe ? 
            <div style={style.cadre}>
                <div className="cote" style={style.coteBas}><div style={style.cote}></div></div>
                <div className="cote" style={{...style.coteBas, top:12}}><div style={style.cote}></div></div>
                <div className="cote" style={{...style.coteBas, top:2, left:10}}><div style={{...style.cote, height:'20px'}}></div></div>
                <div className="cote" style={{...style.coteBas, top:10, left:10}}><div style={{...style.cote, height:'20px'}}></div></div>
            </div>
            :
            <div style={style.cadre}>
                <div className="cote" style={style.coteGauche}><div style={style.cote}></div></div>
                <div className="cote" style={style.coteDroite}><div style={style.cote}></div></div>
                <div className="cote" style={style.coteHaut}><div style={style.cote}></div></div>
                <div className="cote" style={style.coteBas}><div style={style.cote}></div></div>
                {this.props.isorel ? <div style={style.isorel}></div> :''}
                {this.props.typevitre !== '' ? <div className={`vitre ${this.props.typevitre}`} style={style.vitre}></div> : ''}
            </div>
        }
        </>
    )
  }

}

IconeService.propTypes = {
  precoupe:PropTypes.bool,
  isorel:PropTypes.bool,
  typevitre:PropTypes.string
}
IconeService.defaultProps = {
    typevitre: '',
    precoupe: false,
    isorel: false   
}

export default IconeService